import store from 'store'
import { createRouter, createWebHistory } from 'vue-router'
import type { Router } from 'vue-router'
import { nextTick } from 'vue'
import routes from './routes'
import isEmpty from 'lodash/isEmpty'
import { useCookies } from 'vue3-cookies'
import { ID_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'core/constants'
const router: Router = createRouter({
  history: createWebHistory(),
  routes,
})
const { cookies } = useCookies()

router.beforeEach(async (to, _, next) => {
  const isLoginPage = to.matched.some((p) => p.path.indexOf('/login') === 0)
  try {
    const isAuthenticated: boolean = store.getters['auth/isAuthenticated']
    const requiresAuth: boolean = to.meta.requiresAuth as boolean
    const notFound = !routes.some((route) => to.matched.some((m) => m.path === route.path))

    if (notFound) {
      store.commit('SET_STATUS_CODE', 404)
      return next('/error')
    }

    if (isAuthenticated && isLoginPage) {
      return next('/')
    }

    if (requiresAuth && !isAuthenticated) {
      if (!cookies.isKey(ID_TOKEN_KEY) || !cookies.isKey(REFRESH_TOKEN_KEY)) {
        return next('/login')
      }
      store.commit('auth/SET_AUTHENTICATED', true)
      await store.dispatch('auth/actRenewToken')
      nextTick(() => {
        store.dispatch('user/actGetMe').then(() => store.dispatch('division/actGetAllRegion'))
      })
      return next()
    }

    const authUser = store.getters['user/user']
    if (isAuthenticated && isEmpty(authUser)) {
      const user = await store.dispatch('user/actGetMe')
      await store.dispatch('division/actGetAllRegion')
      checkIsTemporary(user.isTemporary, next)
    }

    const authRole = store.getters['user/authRole'] as string
    updateCurrentCompany(authRole)
    if (Array.isArray(to.meta.roles) && to.meta.roles.length && !to.meta.roles.includes(authRole)) {
      store.commit('SET_STATUS_CODE', 403)
      return next('/error')
    }

    return next()
  } catch (err) {
    return isLoginPage ? next() : next('login')
  }
})

const checkIsTemporary = (isTempo: boolean, cb: (arg: string) => void) => {
  if (isTempo) return cb('/change-password')
}

const updateCurrentCompany = (role: string) => {
  if (role && role !== localStorage.getItem('curRole')) {
    localStorage.setItem('curRole', role)
    store.commit('division/SELECT_COMPANY', {
      company: '',
      region: '',
    })
  }
}

export default router
